<template>
  <div class="header">
    <!-- <p>华龙区农村集体资产管理平台</p> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style scoped>
.header {
  display: block;
  width: 1200px;
  height: 590px;
  margin: 0 auto;
}
.header p {
  width: auto;
  height: 79px;
  font-size: 60px;
  font-family: MicrosoftYaHei-Bold;
  line-height: 79px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 10px;
  opacity: 1;
}
</style>
